import React from "react";
import MainCard from "components/common/card/MainCard";
import { styled } from "@mui/material/styles";

const CardWrapper = styled(MainCard)(
    ({ theme, bgcolor, avatarcolor, height }) => ({
        display: "flex",
        alignItems: "center",
        height: height,
        color: theme.palette.primary.light,
        overflow: "hidden",
        position: "relative",
        boxShadow: "0px 0px 20px rgba(0, 0, 0, 0.1)",
        "&:after": {
            content: '""',
            position: "absolute",
            width: "48%",
            height: 350,
            background: `linear-gradient(180.04deg, ${avatarcolor} -80.94%, rgba(144, 202, 249, 0) 70%)`,
            borderRadius: "50%",
            top: -70,
            left: "-22%",
            zIndex: 10,
        },
        "&:before": {
            content: '""',
            position: "absolute",
            width: "55%",
            height: 95,
            background: `linear-gradient(240deg, ${avatarcolor} -14.02%, rgba(144, 202, 249, 0) 77.58%)`,
            borderRadius: "50%",
            top: -75,
            left: "-20%",
            zIndex: 20,
        },
    })
);

const StatsCardWrapper = ({ children, ...props }) => {
    return <CardWrapper {...props}>{children}</CardWrapper>;
};

export default StatsCardWrapper;
